import { EnvironmentType } from "src/app/common/enums/environmentType";
import { IEnvironment } from "src/app/common/interfaces/environment";

export const environment: IEnvironment = {
  type: EnvironmentType["${NODE_ENV}"],
  connectionPath: "assets/config/connections/connection.json",
  configPath: "assets/config/general/config.json",
  buildId: "${BUILD_ID}",
};
